<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nPigRM/tc-custom/9780935926392.jpg?1686833494339" alt="This image is the cover for the book The Mad Professor's Crapshooting Bible"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Mad Professor's Crapshooting Bible
      </h1>
      <p class="bookDescription body article font2">
        <p>The Mad Professor’s Crapshooting Bible  explains grips, tosses, dice sets, betting, practicing, and how to get away with it in casinos.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tino Gambino
      </h2>
      
      <p class="authorDescription body article">Tino Gambino, AKA the Mad Professor, travels the world beating casinos at craps.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pi Yee Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?244218c7